const inputs = document.querySelectorAll<HTMLInputElement>("input.js-honey")

if (inputs.length) {
  const now = new Date().toJSON().slice(0, 10).replace(/-/g, "/")

  setTimeout(function () {
    inputs.forEach((input) => {
      input.value = `abcd1234-${now}`
    })
  }, 5000)
}
